



















// Import vendors ----------------------------------------------------------------------------------
import { computed, defineComponent, toRefs } from '@vue/composition-api';
// Import types ------------------------------------------------------------------------------------
import type { PropType } from '@vue/composition-api';
import type { FormFieldAutoComplete } from '@/utils/forms.utils';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'FormFieldAutoComplete',
  inheritAttrs: false,
  props: {
    field: {
      type: Object as PropType<FormFieldAutoComplete>,
      required: true
    }
  },
  setup(properties, { slots, attrs }) {
    // Use this property to have typing in DOM
    const { field } = toRefs(properties);

    const hasItem = computed(() => {
      return Boolean(slots.item);
    });

    const hasSelection = computed(() => {
      return Boolean(slots.selection);
    });

    const isDisabled = computed(() => {
      return attrs.disabled ?? properties.field.attributes?.isDisabled ?? false;
    });

    return {
      f: field as any as FormFieldAutoComplete,
      // Flags
      hasItem,
      hasSelection,
      isDisabled
    };
  }
});
